import { render } from "./LbrxPrintTicketsBox.vue?vue&type=template&id=cbf789fa&scoped=true"
import script from "./LbrxPrintTicketsBox.vue?vue&type=script&lang=js"
export * from "./LbrxPrintTicketsBox.vue?vue&type=script&lang=js"

import "./LbrxPrintTicketsBox.vue?vue&type=style&index=0&id=cbf789fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf789fa"]])

export default __exports__